<div class="stack flex-1 overflow-auto" #learnosity_grading></div>
@if (config.request.state === 'initial') {
  <div class="cluster">
    <div>
      <dcr-filled-button (click)="save()" label="Opslaan en sluiten"></dcr-filled-button>
      <dcr-outline-button (click)="close()" label="annuleren"></dcr-outline-button>
    </div>
  </div>
}
